// src/components/PeriodReportView.tsx
import TaskCard from "../components/TaskCard";
import React, { useRef } from "react";
import { exportPeriodPdf } from "../utils/exportPeriodPdf";

// export default function PeriodReport({ report }: { report: any }) {
interface Props {
  report: any;
  projectName: string;
  fromDate: string;
  toDate: string;
}

export default function PeriodReport({
  report,
  projectName,
  fromDate,
  toDate,
}: Props) {
  const reportRef = useRef<HTMLDivElement>(null);
  if (!report) return null;

  

  return (

    // <div className="space-y-10 p-4">
    <div ref={reportRef} className="space-y-10 p-4">

  <div className="flex justify-between items-start mb-6">

    <div>
     {/*  <h1 className="text-2xl font-bold">
        Period Report
      </h1> */}

      <p className="text-gray-600">
        <strong>Project :</strong> {projectName}
      </p>

      <p className="text-gray-600">
        <strong>From :</strong> {fromDate}
      </p>

      <p className="text-gray-600">
        <strong>To :</strong> {toDate}
      </p>
    </div>

    <button
     id="period-export-btn"
      onClick={() => {
        if (reportRef.current) {
          exportPeriodPdf(
            reportRef.current,
            projectName,
            fromDate,
            toDate
          );
        }
      }}
      className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
    >
      Export PDF
    </button>

  </div>
      {/* OVERALL */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Overall Summary</h2>
        <div className="grid grid-cols-3 gap-4 text-center">
          <div className="p-4 border rounded bg-gray-50">
            <div className="text-gray-500 text-sm">Total Snags</div>
            <div className="text-2xl font-bold">{report.overall.totalSnags}</div>
          </div>

          <div className="p-4 border rounded bg-green-100">
            <div className="text-gray-500 text-sm">Closed Before Period</div>
            <div className="text-2xl font-bold">
              {report.overall.closedBeforeFrom}
            </div>
          </div>

          <div className="p-4 border rounded bg-green-200">
            <div className="text-gray-500 text-sm">Closed During Period</div>
            <div className="text-2xl font-bold">
              {report.overall.closedDuring}
            </div>
          </div> 
        </div> 
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">
            New Snags This Period ({report.newSnags.length})
        </h2>
        {report.newSnags.map((t: any) => (
            <TaskCard key={t.taskNo} t={t} />
        ))}
        </section>

        <section>
        <h2 className="text-xl font-semibold mb-2">
            Overdue at From-Date ({report.overdue.overdueFrom.length})
        </h2>
        {report.overdue.overdueFrom.map((t: any) => (
            <TaskCard key={t.taskNo} t={t} />
        ))}
        </section>

        <section>
        <h2 className="text-xl font-semibold mb-2">
            Overdue at To-Date ({report.overdue.overdueTo.length})
        </h2>
        {report.overdue.overdueTo.map((t: any) => (
            <TaskCard key={t.taskNo} t={t} />
        ))}
        </section>

        <section>
        <h2 className="text-xl font-semibold mb-2">
            Overdue Closed in Period ({report.overdue.overdueClosedDuring.length})
        </h2>
        {report.overdue.overdueClosedDuring.map((t: any) => (
            <TaskCard key={t.taskNo} t={t} />
        ))}
        </section>

        <section>
        <h2 className="text-xl font-semibold mb-2">
            Postponed Snags ({report.postponed.length})
        </h2>
        {report.postponed.map((t: any) => (
            <TaskCard key={t.taskNo} t={t} />
        ))}
        </section>

        <section>
        <h2 className="text-xl font-semibold mb-2">
            Late Start ({report.lateStart.length})
        </h2>
        {report.lateStart.map((t: any) => (
            <TaskCard key={t.taskNo} t={t} />
        ))}
        </section>

        <section>
        <h2 className="text-xl font-semibold mb-2">
            On Progress ({report.onProgress.length})
        </h2>
        {report.onProgress.map((t: any) => (
            <TaskCard key={t.taskNo} t={t} />
        ))}
        </section>

        <section>
  <h2 className="text-xl font-semibold mb-2">
    Tasks On Hold ({report.onHold?.length || 0})
  </h2>

  {(!report.onHold || report.onHold.length === 0) && (
    <p className="text-gray-500 text-sm">
      No tasks on hold
    </p>
  )}

  {report.onHold?.map((t: any) => (
    <TaskCard key={t.taskNo} t={t} />
  ))}
</section>

    </div>
  );
}
